module.exports = __webpack_public_path__ + "img/thumb_25.ce5d4d88.jpg";